import ShoppingCartMembershipProductRow from '@components/ShoppingCartMembershipProductRow';
import ExpandPanel from '@monofront/design-system/components/ExpandPanel';
import { useTranslations } from 'next-intl';
import React from 'react';

interface IMembershipProductVersionBProps {
  isSideShoppingCart?: boolean;
  isImageLarge?: boolean;
}

const MembershipProductVersionB: React.FC<IMembershipProductVersionBProps> = ({
  isSideShoppingCart,
  isImageLarge,
}) => {
  const tCart = useTranslations('Cart');

  return (
    <div className="container" data-testid="MaaP-SubscriptionProduct">
      <ExpandPanel.Details defaultExpanded>
        <ExpandPanel.Summary UNSAFE_className="tw-rounded-md tw-bg-beige-200 tw-px-4 tw-py-3">
          <p className="tw-font-semibold">
            {tCart('MembershipProductCart.sectionTitle')}
          </p>
          <ExpandPanel.ExpandIcon />
        </ExpandPanel.Summary>
        <ShoppingCartMembershipProductRow
          isSideShoppingCart={isSideShoppingCart}
          isImageLarge={isImageLarge}
        />
      </ExpandPanel.Details>
    </div>
  );
};

export default MembershipProductVersionB;
